import { ReportBetTypes } from "app/utils/const";
import cx from "classnames";
import isEmpty from "lodash/isEmpty";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { SessionHelper } from "../../../../helpers/sessionHelper";
import ReportsScreenFinanceSummary from "./components/ReportsScreenFinanceSummary/ReportsScreenFinanceSummary";
import ReportsScreenRouter from "./components/ReportsScreenRouter/ReportsScreenRouter";
import "./ReportsScreenDesktop.scss";

const DesktopReportsScreen = (props: {
  showNotificationDisplay: boolean;
}): React.JSX.Element => {
  const location = useLocation();
  const [reportType, setReportType] = useState<string>(ReportBetTypes.OPENBETS);
  let { showNotificationDisplay } = props;
  // logic for replacing withRouter with useLocation hook
  useEffect(() => {
    if (!isEmpty(location)) {
      // check if location object contains either of the following strings openbets or statement
      if (location.pathname.indexOf("openbets") > -1) {
        setReportType(ReportBetTypes.OPENBETS);
      } else if (location.pathname.indexOf("statement") > -1) {
        setReportType(ReportBetTypes.STATEMENT);
      }
    }
  }, [location]);

  return (
    <div
      className={cx("reports-screen-wrapper", {
        "reports-screen-wrapper--notifications-active": showNotificationDisplay,
        "reports-screen-wrapper-asian":
          SessionHelper.isAsianRouteAndSessionView(),
      })}
    >
      <ReportsScreenFinanceSummary reportType={reportType} />
      <ReportsScreenRouter />
    </div>
  );
};

const mapStateToProps = (state: {
  notificationListModel: { showNotificationDisplay: boolean };
}) => ({
  showNotificationDisplay: state.notificationListModel.showNotificationDisplay,
});

export default connect(mapStateToProps, null)(DesktopReportsScreen);
